import { ModeId } from '@wix/add-panel-common';
import { any } from 'ramda';
import type { ConditionHelpers } from '../../UtilsProvider/UtilsProvider.types';

const checkMode =
  (conditionHelpers: ConditionHelpers) =>
  (mode: ModeId): boolean => {
    const { isMobileEditorOn = () => true } = conditionHelpers;

    switch (mode) {
      case ModeId.Desktop:
        return !isMobileEditorOn();
      case ModeId.Mobile:
        return isMobileEditorOn();
      default:
        return false;
    }
  };

export const checkModes = (modes: ModeId[], conditionHelpers: ConditionHelpers): boolean =>
  any(checkMode(conditionHelpers), modes);
